export const getErrorMessage = (e) => e.response?.data?.message || e.message

export const getError = (e) => e.response?.data || e

export default null
